<template>
  <v-card>
    <v-card-title> {{ model && model.Id ? "Edit Language" : "Add Language" }} </v-card-title>
    <v-card-text>
      <v-form ref="frmRegister" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12">
            <InfoBox title="Add your language here" />
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <AutoCompleteField
              :readonly="isHiringmanager"
              dense
              label="Language"
              placeholder="Select Language..."
              v-model="model.Language"
              :items="languages"
              outlined
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12 pb-0">
            <span class="f-body-1">Skill Level</span>
          </v-col>
          <v-col md="6" cols="12">
            <v-radio-group :readonly="isHiringmanager" class="mt-0" :rules="[rules.required]" v-model="model.Level" column>
              <v-radio label="Basic" value="Basic"></v-radio>
              <v-radio label="Intermediate" value="Intermediate"></v-radio>
              <v-radio label="Advanced" value="Advanced"></v-radio>
              <v-radio label="Native" value="Native"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <TextAreaField :readonly="isHiringmanager" v-model="model.Description" outlined label="Description" placeholder="Description" />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn v-if="!isHiringmanager" class="secondary_btn" @click="cancel()" :loading="loading" prepend-icon="mdi-cancel"> Cancel</v-btn>
      <v-btn v-if="!isHiringmanager" class="primary_btn" @click="save()" :loading="loading" prepend-icon="mdi-check">{{
        model.Id == "" ? "Add Language" : "Save Language"
      }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { LanguageSkill } from "../../../models/Teammember";
import { Profile } from "../../../definitions/config";
import AutoCompleteField from "../../Fields/AutoCompleteField.vue";
import TextAreaField from "../../Fields/TextAreaField.vue";
import InfoBox from "../../InfoBox.vue";
import rules from "../../../utils/validations";

export default defineComponent({
  props: ["editingItem", "addLoading", "isAfterSignUp", "isGettingLanguages", "isHiringmanager"],
  components: {
    AutoCompleteField,
    TextAreaField,
    InfoBox,
  },
  data() {
    return {
      rules,
      languages: Profile.Members.Languages,
      endDatePickerMenu: false,
      startDatePickerMenu: false,
      loading: false,
      valid: true,
      startMenu: false,
      endMenu: false,
      model: {
        Id: "",
        Language: null,
        Level: "",
        Description: "",
      } as LanguageSkill,
    };
  },
  methods: {
    cancel(): void {
      this.$emit("cancel");
    },
    async save(): Promise<void> {
      const isValid = (await (this.$refs.frmRegister as any).validate()).valid;
      if (isValid) {
        this.$emit("saved", {
          model: this.model,
          callbackMethod: () => {
            this.resetForm();
            this.$emit("cancel");
          },
        });
      } else {
        if (this.isGettingLanguages) {
          this.$emit("saved");
        }
      }
    },
    resetForm() {
      this.model = {
        Id: "",
        Language: "",
        Level: "",
        Description: "",
      };
      this.loading = false;
    },
  },
  mounted() {
    this.model = { ...this.editingItem };
  },
  watch: {
    isGettingLanguages(newVal) {
      if (newVal) {
        this.save();
      }
    },
    addLoading(newVal) {
      this.loading = newVal;
    },
  },
});
</script>
